/* eslint-disable no-case-declarations */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
/* eslint-disable no-undef */
import Themes from "../themes";
import Url from "../utils/url";
import { defer, extend } from "../utils/core";


class ExThemes extends Themes {
	constructor(rendition){
		super(rendition);

		this._themes = {
			"common" : {
				"rules" : {},
				"url" : "",
				"serialized" : ""
			},
			"readSetting" : {
				"rules" : {},
				"url" : "",
				"serialized" : ""
			},
			"writingMode" : {
				"serialized" : ""
			}
		};

		this._current = null;

		this._totalOutterCss = 0;
		this._resolveOutterCss = 0;

		//0.加入目前選擇字型、行高屬性----------------------------------------------------------------------
		let readSetting = rendition.settings.readSetting || {};
		this._booksFontSize = readSetting.font_size || rendition.settings.defaultFontSize;
		this._booksBackground = readSetting.theme || "default";
		this._booksFont = readSetting.font_family || "initial";
		this._booksLineHeight = readSetting.line_height || rendition.settings.defaultLineHeight;
		if(rendition.settings.layout === 'pre-paginated'){
			this._booksWritingMode = "initial";
		}else{
			this._booksWritingMode = readSetting.writing_mode || "initial";
		}

		//1.加入預設主題-----------------------------------------------------------------------------------
		//共用規則
		this._defaultCssBlobUrl = {};
		this._replaceDefaultCss = $.Deferred();
		if(rendition.settings.defaultCss){
			var url = new Url(rendition.settings.defaultCss);
			this.register(url.href);
		}else{
			this._replaceDefaultCss.resolve();
		}

		//主題
		if(rendition.settings.themeCss){
			for (const name in rendition.settings.themeCss) {
				var url = new Url(rendition.settings.themeCss[name]);
				this.register(name, url.href);
			}
		}

		//2.建立版面原則----------------------------------------------------------------------------------	
		//流動版
		this._booksReflowableRule = {
			"html":{},
			"body":{
				"background-color":"transparent",
				"transform":"initial !important",
				"line-height":"initial",
				"font-size": this._booksFontSize+" !important"
			},
			"table":{
				"font-size": this._booksFontSize+" !important"
			},
		};
		//固定版
		this._booksPrePaginatedRule = {
			"body":{
				"background-color":"transparent"
			}
		};

		if(rendition.settings.layout === "reflowable"){
			this._setBooksFontAndLineHeight(true);
		}
	}

	/**
	 * Add a default theme to be used by a rendition
	 * @param {object | string} theme
	 * @example themes.register("http://example.com/default.css")
	 * @example themes.register({ "body": { "color": "purple"}})
	 */
	 default (theme) {
		if (!theme) {
			return;
		}
		if (typeof(theme) === "string") {
			return this.registerUrl("common", theme);
		}
		if (typeof(theme) === "object") {
			return this.registerRules("common", theme);
		}
	}

	/**
	 * Register a theme by passing its css as string
	 * @param {string} name 
	 * @param {string} css 
	 */
	 registerCss (name, css) {
		this._themes[name] = { "serialized" : css };
		if (this._injected[name] || name == 'writingMode') {
			this.update(name);
		}
	}

	/**
	 * Register a url
	 * @param {string} name
	 * @param {string} input
	 */
	 registerUrl (name, input) {
		
		this._totalOutterCss += 1;
		var url = new Url(input);

		let cssFixBlob, cssFixBlobUrl;
		let replaceDefaultCss = $.Deferred();

		let defaultCssBlobLink = this.rendition.book.getBlobCache(url.href);
		if(!defaultCssBlobLink){
			$.ajax({
				context: this,
				xhrFields: { withCredentials: true },
				url: url.href,
				type: "GET",
				cache: false,
				xhr: function () {
					var xhr = new XMLHttpRequest();
					xhr.responseType= "blob";
					return xhr;
				}
				,success: function(blob){

					let blobLoading, blobLoaded, blobReader;
					if(blob.text){
						blobLoaded = blob.text();
					}else{
						blobLoading = new defer();
						blobLoaded = blobLoading.promise;
						blobReader = new FileReader();
						blobReader.addEventListener("load", function () {
							blobLoading.resolve(blobReader.result);
						});
						blobReader.addEventListener("error", function (error) {
							blobLoading.reject(error);
						});
						blobReader.readAsText(blob);
					}

					blobLoaded.then(cssTxt => {

						//預存載入完成時要置換的連結
						let cssHref = url.href;
						let themeName = name;

						//處理 css 中使用的連結
						let urlsArry = cssTxt.match(/\w+[\s\:]+url\((.*?)(?=\))/g);
						let urls = [];
						let unResolveUrls = [];
						$(urlsArry).each((index, url) => {
							if (url.match(/^\b\w+/g)[0] != "import") {
								urls.push(url.match(/url\((.*?)+/g)[0]);
							}
						});
						if(urls.length && this.rendition){
							$(urls).each((index, url) => {
								let lnkString = url.replace("url(", "");
								if(!this.rendition.book.settings.encryptType){
									lnkString = lnkString.replace("../fonts", "./assets/fonts");
								}
								let lastQuote = $.inArray(lnkString.slice(-1), ["\"", "'"]) > -1 ? lnkString.slice(-1) : "";
								let keyUrl = lastQuote ? lnkString.slice(1, lnkString.length - 1) : lnkString;
								unResolveUrls.push(keyUrl);
								$.ajax({
									context: this,
									xhrFields: { withCredentials: true },
									url: keyUrl,
									type: "GET",
									cache: false,
									xhr: function () {
										var xhr = new XMLHttpRequest();
										xhr.responseType= "blob";
										return xhr;
									}
									,success: function(fontBlob){
										let urlArr = "url(" + lastQuote + window.URL.createObjectURL(fontBlob) + lastQuote;
										let pattern = new RegExp("[\"'-()?=_&~./]");
										let rs = "";
										for (let i = 0; i < url.length; i++) {
											rs += url.slice(i, i + 1).replace(pattern, "\\" + url.substr(i, 1));
										}
										cssTxt = cssTxt.replace(new RegExp(rs, "g"), urlArr);
										unResolveUrls.splice(unResolveUrls.indexOf(keyUrl),1);
										if(!unResolveUrls.length && this._defaultCssBlobUrl && this.rendition){
											//字型載入完, 再次置換 BLOB
											cssFixBlob = new Blob([cssTxt], {type: "text/css"});
											cssFixBlobUrl = window.URL.createObjectURL(cssFixBlob);
											this._defaultCssBlobUrl[cssHref] = cssFixBlobUrl;
											this._themes[themeName] = { "url": cssFixBlobUrl.toString() };
											this.rendition.book.updateBlobCache(cssHref, cssFixBlobUrl);
										}
									},
									error:function(err){
										replaceDefaultCss.reject(err);
									}
								});
							});
						}else{
							replaceDefaultCss.resolve(cssTxt);
						}
					}, (err) => {
						replaceDefaultCss.reject(err);
					});
				},
				error:function(err){
					replaceDefaultCss.reject(err);
				}
			});

			//不等待字型載入
			replaceDefaultCss.resolve();
			return replaceDefaultCss.then( () => { 
				this._defaultCssBlobUrl[url.href] = url.href;
				this._themes[name] = { "url": url.href.toString() };
				if (this._injected[name] || name == "common" || name == "readSetting") {
					this.update(name);
				}

				this._resolveOutterCss += 1;
				if(this._totalOutterCss === this._resolveOutterCss){
					this._replaceDefaultCss.resolve();
				}
			}, (err) => {
				console.log(err);
				this._replaceDefaultCss.resolve();
			});

		}else{
			replaceDefaultCss.resolve();
			return replaceDefaultCss.then( () => { 
				this._defaultCssBlobUrl[url.href] = defaultCssBlobLink;
				this._themes[name] = { "url": defaultCssBlobLink.toString() };
				if (this._injected[name] || name == "common" || name == "readSetting") {
					this.update(name);
				}

				this._resolveOutterCss += 1;
				if(this._totalOutterCss === this._resolveOutterCss){
					this._replaceDefaultCss.resolve();
				}
			}, (err) => {
				console.log(err);
				this._replaceDefaultCss.resolve();
			});
		}

		
	}

	/**
	 * Register rule
	 * @param {string} name
	 * @param {object} rules
	 */
	 registerRules (name, rules) {
		this._themes[name] = { "rules": rules };
		// TODO: serialize css rules
		if (this._injected[name] || name == "common" || name == "readSetting") {
			this.update(name);
		}
	}

	/**
	 * Inject all themes into contents
	 * @param {Contents} contents
	 */
	 inject (contents) {

		return this._replaceDefaultCss.then(()=>{

			var links = [];
			var themes = this._themes;
			var theme;

			for (var name in themes) {
				if (themes.hasOwnProperty(name) && (name === this._current || name == "common" || name == "readSetting" || name == "writingMode")) {
					theme = themes[name];
					if((theme.rules && Object.keys(theme.rules).length > 0) || (theme.url && links.indexOf(theme.url) === -1) || theme.serialized) {
						this.add(name, contents);
					}
					this._injected.push(name);
				}
			}

			if(this._current != "common" && this._current != "readSetting" && this._current != "writingMode") {
				contents.addClass(this._current);
			}
		});
	}

	preloadDefaultCssToBlob(){
		return this._replaceDefaultCss;
	}

	hookManagerEvent(manager){
		manager.hooks.afterIframeOnload.register(this.preloadDefaultCssToBlob.bind(this));
	}

	//同步主題
	sync(theme){
		if(theme){
			this._booksFontSize = theme._booksFontSize;
			this._booksBackground = theme._booksBackground;
			this._booksFont =  theme._booksFont;
			this._booksLineHeight = theme._booksLineHeight;
			this._booksWritingMode = theme._booksWritingMode;
			this._setBooksFontAndLineHeight();
		}
	}

	/**
	 * Adjust the font size of a rendition
	 * @param {number} size
	 */
	 fontSize (size) {

		//發出閱讀設定更改事件
		this.rendition.updateReadSetting();
		 
		//清空畫面
		this.rendition.manager.clear();

		//更新css
		this._booksFontSize = size;
		this._setBooksFontAndLineHeight();

		//加入 remap 觸發點
		this.rendition._triggerRemap = true;

		//重新display
		this.rendition.onReaderSettingDisplay();
	}

	/**
	 * Adjust the font-family of a rendition
	 * @param {string} background
	 */
	 background (background) {
		this._booksBackground = background;
		this._setBooksFontAndLineHeight();
	}

	/**
	 * Adjust the font-family of a rendition
	 * @param {string} f
	 */
	 font (f) {

		//發出閱讀設定更改事件
		this.rendition.updateReadSetting();

		//清空畫面
		this.rendition.manager.clear();

		//更新css
		this._booksFont = f;
		this._setBooksFontAndLineHeight();

		//加入 remap 觸發點
		this.rendition._triggerRemap = true;

		//重新display
		this.rendition.onReaderSettingDisplay();
	}

	/**
	 * Adjust the line height of a rendition
	 * @param {string} height
	 */
	 lineHeight (height) {

		//發出閱讀設定更改事件
		this.rendition.updateReadSetting();

		//清空畫面
		this.rendition.manager.clear();

		//更新css
		this._booksLineHeight = height;
		this._setBooksFontAndLineHeight();

		//加入 remap 觸發點
		this.rendition._triggerRemap = true;

		//重新display
		this.rendition.onReaderSettingDisplay();
	}

	/**
	 * Adjust the writing-mode of a rendition
	 * @param {string} mode
	 */
	writingMode (mode) {
		//發出閱讀設定更改事件
		this.rendition.updateReadSetting();

		//清空畫面
		this.rendition.manager.clear();

		//更新css
		this._booksWritingMode = mode;
		this._setBooksFontAndLineHeight();

		//加入 remap 觸發點
		this.rendition._triggerRemap = true;

		//重新display
		this.rendition.onReaderSettingDisplay();
	}

	/**
	 * Select a theme
	 * @param {string} name
	 * @param {bool} withOverRideMode
	 */
	 select (name, withOverRideMode = false) {
		var prev = this._current;
		var contents;

		this._current = name;

		this.update(name, withOverRideMode);

		contents = this.rendition.getContents();
		contents.forEach( (content) => {
			if(prev){
				content.removeClass(prev);
			}
			content.addClass(name);
		});
	}

	/**
	 * Update a theme
	 * @param {string} name
	 * @param {bool} withOverRideMode
	 */
	 update (name, withOverRideMode = false) {
		var contents = this.rendition.getContents();
		contents.forEach( (content) => {
			this.add(name, content, withOverRideMode);
		});
	}

	/**
	 * Add Theme to contents
	 * @param {string} name
	 * @param {Contents} contents
	 * @param {bool} withOverRideMode
	 */
	 add (name, contents, withOverRideMode = false) {
		var theme = this._themes[name];

		if (!theme || !contents) {
			return;
		}

		if (theme.url) {
			contents.addStylesheet(theme.url, name);
		} else if (theme.serialized) {
			contents.addStylesheetCss(theme.serialized, name);
			theme.injected = true;
		} else if (theme.rules) {
			contents.addStylesheetRules(theme.rules, name, withOverRideMode);
			theme.injected = true;
		}
	}

	_setBooksFontAndLineHeight(isInit = false){
		let finalRule = {};

		switch(this.rendition.settings.layout){
		case "reflowable": //流動版預設原則 
						   extend(finalRule, this._booksReflowableRule);
						   //書寫方向
						   if(this._booksWritingMode !== "initial"){
									switch(this._booksWritingMode){
										case 'horizontal':  this._themes['writingMode'].serialized = "html, body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, p, pre, code, blockquote{ writing-mode:horizontal-tb !important; -webkit-writing-mode:horizontal-tb !important; -epub-writing-mode:horizontal-tb !important; }";
															this._themes['writingMode'].serialized += " table img{ width:100% !important; }";
															this._themes['writingMode'].serialized += " hr{ border-width:1px !important; border-style:solid none none none !important;height:auto !important; }";
															this._themes['writingMode'].serialized += " ruby{ display:flex;flex-direction:column-reverse }";
															if(this.rendition.book.package.metadata.direction !== 'ltr'){
																	//直轉橫
																	this.rendition.updateBookDirection('ltr');
															}
															break;
										case 'vertical':this._themes['writingMode'].serialized = "html, body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, p, pre, code, blockquote{ writing-mode:vertical-rl !important; -webkit-writing-mode:vertical-rl !important; -epub-writing-mode:vertical-rl !important; }";
														this._themes['writingMode'].serialized += " table{ width:auto; }";
														this._themes['writingMode'].serialized += " hr{ border-width:1px !important; border-style:none solid none none !important;width:auto !important; }";
														if(this.rendition.book.package.metadata.direction !== "rtl"){
															//橫轉直
															this.rendition.updateBookDirection('rtl');
														}
														break;
									}
							}else{
								this._themes['writingMode'].serialized = "";
								if(this.rendition.book.package.metadata.direction !== this.rendition.book.package.metadata.defaultDirection){
									this.rendition.updateBookDirection(this.rendition.book.package.metadata.defaultDirection);
								}
							}
						   //字級
						   finalRule["body"]["font-size"] = this._booksFontSize+" !important";
						   finalRule["table"]["font-size"] = this._booksFontSize+" !important";
						   //字型, 行高
		                  let booksRule = {};
		                  let rulePrefix = "html body";
		                  let ruleSelector = ["","*","p","h1","h2","h3","h4","h5","h6","span","div","b"];
		                  ruleSelector.forEach((selector)=>{
							
								let mergeSelector = (selector === "") ? `${rulePrefix}` : `${rulePrefix} ${selector}`;

								booksRule[mergeSelector] = {
									"line-height":`${this._booksLineHeight} !important`
								}

								if(this._booksFont !== "initial"){
									booksRule[mergeSelector]["font-family"] = `${this._booksFont} !important`;
								}
								
		                  });
		                  extend(finalRule, booksRule);
			               break;

		case "pre-paginated": //固定版預設原則 
							  extend(finalRule, this._booksPrePaginatedRule);break;
		}
		
		//註冊規則
		if(isInit){
			extend(this._themes.readSetting.rules, finalRule);
			this.registerRules("readSetting", this._themes.readSetting.rules);
			this.select(this._booksBackground);
		}else{
			this.registerRules("readSetting", finalRule);
			this.update('writingMode');
			this.select(this._booksBackground);
		}
	}

	
	destroy() {
		super.destroy();

		this._defaultCssBlobUrl = undefined;
		this._replaceDefaultCss = undefined;
		this._booksReflowableRule = undefined;
		this._booksPrePaginatedRule = undefined;
	}
}

export default ExThemes;